import { Component, OnInit } from '@angular/core';
import { BaseAutorizeComponent } from '../shared/base-authorize.component';
import { AzureFunctionsService, IProcess, ProcessStatusEnumNames, ProcessStatusEnum } from '../azurefunctions/azure-functions.service';

@Component({
  selector: 'app-process-history',
  templateUrl: './process-history.component.html',
  styleUrls: ['./process-history.component.css']
})
export class ProcessHistoryComponent implements OnInit {

  // workaround to access enums in template 
  processStatusEnum: any = ProcessStatusEnum;
  processStatusEnumNames: any = ProcessStatusEnumNames;
  errorMessage: string;
  loading: boolean = true;

  constructor(private functionsService: AzureFunctionsService) { }

  processes: IProcess[];

  ngOnInit() {
    this.functionsService.getProcessHistory().then((p) => {
      this.processes = p;
      this.loading = false;
    },
    () => this.loading = false);
  }

  downloadLogs(processId: string){
      this.functionsService.downloadProcessHistory(processId).then( b => {
        this.downloadFile(b, processId);
      },
      (e) => {this.errorMessage = "Unable to download process history: " + e});
      
  }

  downloadFile(blob: Blob, processId: string) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], { type: "application/zip" });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);

    var link = document.createElement('a');
    link.href = data;
    link.download =  processId + ".zip";
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
    }, 100);
  }

}
